import { render } from "./HeroApprovalModal.vue?vue&type=template&id=0deb6b66&scoped=true"
import script from "./HeroApprovalModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalModal.vue?vue&type=script&lang=js"

import "./HeroApprovalModal.vue?vue&type=style&index=0&id=0deb6b66&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0deb6b66"]])

export default __exports__